export const SUCCESS_PAGE_CONTACT_STORAGE_PREFIX = 'sms-campaign-success-contact:';

/** Replaces success-page merge tags with live or preview values. */
export function replaceSuccessPageMergeFields(
  text: string,
  contactValue: string,
  options?: { brandName?: string; firstName?: string }
): string {
  const contact = contactValue?.trim() || '';
  const brand = options?.brandName?.trim() || 'Way';
  const firstName = options?.firstName?.trim() || '';

  return (text || '')
    .replace(/\{customer\s+contact\}/gi, contact)
    .replace(/\{phoneNumber\}/gi, contact)
    .replace(/\{phonenumber\}/gi, contact)
    .replace(/\{firstName\}/gi, firstName)
    .replace(/\{brandName\}/gi, brand);
}

export function persistSmsSuccessContact(campaignId: string, contact: string): void {
  const id = campaignId?.trim();
  const value = contact?.trim();
  if (!id || !value) {
    return;
  }

  try {
    sessionStorage.setItem(`${SUCCESS_PAGE_CONTACT_STORAGE_PREFIX}${id}`, value);
  } catch {
    // Ignore storage failures (private mode, quota, etc.).
  }
}

export function readSmsSuccessContact(
  campaignId: string,
  navigationState?: { contactValue?: string }
): string {
  const fromState = navigationState?.contactValue?.trim();
  if (fromState) {
    return fromState;
  }

  const id = campaignId?.trim();
  if (!id) {
    return '';
  }

  try {
    return sessionStorage.getItem(`${SUCCESS_PAGE_CONTACT_STORAGE_PREFIX}${id}`)?.trim() || '';
  } catch {
    return '';
  }
}
